import {BaseRepository} from "../../../infrastructure/BaseRepository";
import userResource from "../resources/UserResource";

class UserRepository extends BaseRepository {
    constructor() {
        super(userResource)
    }

    /**
     * @public
     * @param {User} user
     * @param {any} profileInfo
     */
    saveProfileInfo(user, profileInfo) {
        const id = this._resolveUserId(user);
        const requestData = {id, ...profileInfo};
        return this.patch(requestData);
    }

    _resolveUserId(user) {
        if (user.uid != null) {
            return user.uid;
        }
        return user[this.entityIdName];
    }
}

const userRepository = new UserRepository();

export default userRepository;
